// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"760":"3b53517f","1221":"3b53517f","2827":"3b53517f","3550":"3b53517f","4347":"3b53517f","5875":"3b53517f","5908":"3b53517f","6550":"3b53517f","7040":"3b53517f","7632":"3b53517f"}[chunkId] + ".chunk.css";
};